<template>
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-3">
        <button
            v-for="palette in palettes"
            :key="palette.id"
            type="button"
            class="rounded-xl border-2 p-2 text-left transition"
            :class="
                selectedId === palette.id
                    ? 'border-brand-purple border-4'
                    : 'border-theme-border hover:border-brand-red'
            "
            @click="$emit('select', palette)"
        >
            <palette-catalog-thumbnail
                :colors="palette.colors"
                :business-name="businessName"
                :logo-url="logoUrl"
                :display-mode="displayMode"
            />
            <p class="mt-2 text-sm font-medium text-theme-base">
                {{ palette.label }}
            </p>
        </button>
    </div>
</template>

<script>
import PaletteCatalogThumbnail from "@/components/editor/PaletteCatalogThumbnail.vue";

export default {
    name: "PaletteGrid",
    components: { PaletteCatalogThumbnail },
    props: {
        palettes: {
            type: Array,
            required: true
        },
        selectedId: {
            type: String,
            default: ""
        },
        businessName: {
            type: String,
            default: ""
        },
        logoUrl: {
            type: String,
            default: ""
        },
        displayMode: {
            type: String,
            default: "catalog"
        }
    }
};
</script>
